exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Challenges-Challenges__challengeIndication--2XsTp{position:absolute;width:36rem;text-align:center;line-height:36rem;font-size:30rem;z-index:1;bottom:-10rem;left:0}.src-components-Challenges-Challenges__expanded--1982g{width:36rem;height:36rem;color:#fff;background-color:#000}", ""]);
// Exports
exports.locals = {
	"challengeIndication": "src-components-Challenges-Challenges__challengeIndication--2XsTp",
	"expanded": "src-components-Challenges-Challenges__expanded--1982g"
};